import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 22,
	viewBox: "0 0 41 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 18.75L17.4066 4.28152C19.108 2.57282 21.892 2.57282 23.5934 4.28152L38 18.75",
		stroke: "currentColor",
		strokeWidth: 5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgButtonArrowUp;
